import React, { useState, useEffect } from "react";

// List of 100 random objects (emojis or icons)
const objects = [
    "🍎", "🍌", "🍇", "🍒", "🍊", "🍓", "🍉", "🍍", "🥥", "🥝", // Fruits
    "🍒", "🍓", "🍍", "🍅", "🍏", "🍊", "🍋", "🍍", "🍎", "🍑", // Fruits continued
    "🌟", "🌸", "🌼", "🌷", "🌻", "💐", "🌺", "🌹", "🌻", "🏵️", // Flowers
    "🐶", "🐱", "🐰", "🐻", "🦁", "🐯", "🦄", "🐨", "🦊", "🐵", // Animals
    "🦓", "🦒", "🐺", "🦝", "🦥", "🐯", "🦀", "🐧", "🐦", "🦣", // More Animals
    "🚗", "🚲", "🛵", "🛴", "🚂", "🚎", "🚙", "🛺", "🚓", "🚕", // Vehicles
    "🚍", "🛻", "🚐", "🚛", "🚜", "🏎️", "🚁", "✈️", "🚢", "🛥️", // More Vehicles
    "🎮", "🏀", "⚽", "🏈", "🎾", "🎱", "🏓", "🏸", "⛳", "🥅", // Sports/Activities
    "🏏", "🏐", "🏒", "🏑", "🤾‍♂️", "🤾‍♀️", "🧘‍♂️", "🧘‍♀️", "🚴‍♂️", "🚴‍♀️", // More Sports/Activities
    "🎨", "🎭", "🎤", "🎧", "🎶", "🎷", "🎸", "🎻", "🎺", "🪕", // Musical Instruments
    "🖌️", "🖍️", "🎬", "🎥", "📸", "📷", "📹", "📺", "📱", "🖥️", // Electronics
    "💻", "⌚", "📞", "📟", "📠", "🖨️", "📦", "📬", "📤", "📥", // More Electronics
    "🎁", "🎈", "🎉", "🎊", "🎀", "✨", "💥", "🎇", "🎆", "🎋", // Decorations
    "🧸", "🪀", "🪁", "🪄", "🎳", "🎯", "🎮", "🃏", "♟️", "🧩", // Toys & Games
    "🥇", "🥈", "🥉", "🏆", "🥋", "🏅", "🎖️", "🥅", "⛷️", "🏂", // Trophies & Medals
    "🔑", "🔒", "🛠️", "⚙️", "🧰", "🔨", "🔧", "🔩", "🧱", "🪓", // Tools & Hardware
    "💎", "🪙", "💰", "💸", "🛍️", "🛒", "🎁", "💳", "🪙", "💴", // Currency & Shopping
    "👑", "👒", "🎩", "🧢", "🕶️", "🥽", "👓", "👠", "👡", "🥿", // Fashion Accessories
    "👗", "👚", "👕", "🧥", "👖", "👕", "👔", "👖", "👞", "👢", // Clothing
    "💍", "📿", "🦷", "🦴", "👝", "🎒", "🧳", "👜", "👛", "🕶️", // Accessories
    "🥄", "🍴", "🍽️", "🍷", "🥂", "🍻", "🍸", "🥃", "🍺", "🥤", // Food & Drinks
    "🧃", "🧉", "🍾", "🍶", "🥛", "🍚", "🍲", "🍗", "🥩", "🍕", // More Food & Drinks
    "🍔", "🍟", "🍪", "🍩", "🥞", "🍫", "🍬", "🍯", "🍪", "🥨", // Snacks
    "🍣", "🍜", "🍛", "🥘", "🍢", "🍤", "🍖", "🍡", "🍦", "🍧", // Asian & Ice Cream Foods
    "🍩", "🍪", "🍭", "🍨", "🍮", "🍫", "🍪", "🍿", "🍩", "🍬", // Sweets and More
    "🧁", "🥧", "🍰", "🥮", "🍪", "🥞", "🍫", "🍩", "🍪", "🫛", // Desserts
    "🎤", "🎧", "🎸", "🎷", "🎺", "🎹", "🎶", "🎼", "🎵", "🎻" // Music Items
];

const symbols = [">", "<", "="];

const GreaterLessThanMedium: React.FC = () => {
    const [question, setQuestion] = useState<any>(null);
    const [feedback, setFeedback] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    const generateQuestion = () => {
        const count1 = Math.floor(Math.random() * 10) + 1; // Random count for left side (1-10)
        const count2 = Math.floor(Math.random() * 10) + 1; // Random count for right side (1-10)

        // Randomly select objects for both sides
        const object1 = objects[Math.floor(Math.random() * objects.length)];
        const object2 = objects[Math.floor(Math.random() * objects.length)];

        setQuestion({
            count1,
            count2,
            object1,
            object2,
            text1: Array(count1).fill(object1),
            text2: Array(count2).fill(object2),
        });
    };

    useEffect(() => {
        generateQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Greater Than / Less Than - Medium"; // Set page title
    }, []);

    const handleAnswer = (symbol: string) => {
        if (
            (symbol === ">" && question.count1 > question.count2) ||
            (symbol === "<" && question.count1 < question.count2) ||
            (symbol === "=" && question.count1 === question.count2)
        ) {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion();
                setShowImage(false);
                setError(false);
            }, 2000);
        } else {
            setError(true);
        }
    };

    return (
        <>
            {
                showImage === false ?
                <>
                    <div className='contentPart showCenter  additionWord'>
                        <div className="grid-container text-center">
                                {question && (
                                    <>
                                    <div className="grid-box objects">
                                        {question.text1.map((item: string, index: number) => (
                                            <span key={index}>{item}</span>
                                        ))}
                                    </div>
                                    <div className="grid-box verticalInputBox text-center">
                                        <input
                                            type="text"
                                            placeholder="?"
                                                readOnly
                                            className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                            />
                                    </div>
                                    <div className="grid-box objects">
                                        {question.text2.map((item: string, index: number) => (
                                            <span key={index}>{item}</span>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="optionDiv button-container mt-4 text-center" style={{marginLeft:0}}>
                            {symbols.map((symbol) => (
                                <div className="optionButton" key={symbol} onClick={() => handleAnswer(symbol)}>
                                    {symbol}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default GreaterLessThanMedium;
